import {faHome, faToolbox, faUser, faShareAlt} from "@fortawesome/free-solid-svg-icons"

export default [
    {
        text: "About Me",
        icon: faUser,
        link: "/about"
    },
    {
        text: "Projects",
        icon: faToolbox,
        link: "/projects"
    }
]